define([], () => {
    return ['ContextService', ContextService => ({
            showIsCreatedByDealer: empMode => !(ContextService.isProductCode('PartnerLeasingMotorfahrzeug') && !empMode),

            showIsSelectedDealer: isCreatedByDealer => isCreatedByDealer === false
                && ContextService.isLeasePlan() === false,

            showDealerSelection(empMode, isSelectedDealer, isCreatedByDealer) {
                return empMode !== true && isCreatedByDealer === false && isSelectedDealer === true
                    || empMode !== true && isCreatedByDealer === true && isSelectedDealer === true
                    || empMode === true && isSelectedDealer === true;
            },
            showAddonHandlerFields(empMode, isSelectedDealer, isCreatedByDealer) {
                return empMode === true && isCreatedByDealer !== true && isSelectedDealer === true
                    || isCreatedByDealer === true
                    || ContextService.isLeasePlan() === true
            },
            showDealerIsEmployer(empMode, isSelectedDealer) {
                return empMode === true && isSelectedDealer === true;
            },
            showSellerNumber(isSelectedDealer) {
                return isSelectedDealer === true;
            },
            showSellerEmail(isCreatedByDealer) {
                return isCreatedByDealer === true || ContextService.isLeasePlan() === true;
            },
            getSellerNumberLabelKey(channel) {
                const subKey = ['amag'].includes(channel) ? `.${channel}` : '';
                return `quoteandbind.mfp.directives.templates.mfp-partner-data.SellerNumber${subKey}`;
            },
    })];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/services/MFPPartnerService.js